import React, { Fragment } from 'react'
import { formatMoney } from '../../../../../helpers/DateFormat';
interface AmountCalcViewProps {
    totalProductAmt: number | string;
    vatPerc: number;
    disAmt: number;
    disPerc: number;
    finalTotalAmt: number;
}
const AmountCalcView: React.FC<AmountCalcViewProps> = ({ totalProductAmt, vatPerc, disAmt, disPerc, finalTotalAmt }) => {
    return (
        <Fragment>
            <div className='flex justify-end border-t border-gray-50 p-2'>
                <ul className='list-none text-[13px] space-y-0.5 font-normal text-gray-500'>
                    <li>Product Total Amount: <span className='text-red-500 font-semibold'>{formatMoney(parseFloat(totalProductAmt?.toString()))}</span></li>
                    <li>VAT Percentage: {vatPerc}%</li>
                    <li>Discount Amount: {formatMoney(disAmt || 0)}</li>
                    <li>Discount Percentage: {disPerc}%</li>
                    <li className='border-t border-gray-200 text-green-500 font-bold'>Final Total Amount: {formatMoney(finalTotalAmt || 0)}</li>

                </ul>
            </div>
        </Fragment>
    )
}

export default AmountCalcView